import React, { useState, useEffect } from 'react';
import { TimeDisplay } from '../ui';
import { BackgroundImage } from '../ui';
import styles from '../../styles/components/layout/page-header.module.css';

const PageHeader: React.FC = () => {
  const [deptName, setDeptName] = useState<string>('');
  const [headerImageSrc, setHeaderImageSrc] = useState<string>(
    require('../../assets/images/header/header-title.png')
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const name = params.get('deptName');
    if (name) {
      setDeptName(decodeURIComponent(name));
    }

    const flag = params.get('flag');
    if (flag === 'future') {
      setHeaderImageSrc(require('../../assets/images/header/header-title-future.png'));
    } else {
      // flag为canteen或者为空时使用默认图片
      setHeaderImageSrc(require('../../assets/images/header/header-title.png'));
    }
  }, []);

  return (
    <header className={styles.pageHeader}>
      <div className={styles.leftSection}>
        {deptName && <div className={styles.deptName}>{deptName}</div>}
      </div>
      
      <div className={styles.centerSection}>
        <BackgroundImage 
          src={headerImageSrc}
          className={styles.headerTitle}
          alt="校园餐常态化监管预警中心"
        />
      </div>
      
      <div className={styles.rightSection}>
        <TimeDisplay 
          format="yyyy年MM月dd日eeee HH:mm:ss"
          className={styles.headerTime}
        />
      </div>
    </header>
  );
};

export default PageHeader;